import { registerView, View, ViewComponent } from "@frui.ts/views";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import { observer } from "mobx-react-lite";
import React from "react";
import BankTransferViewModel from "viewModels/common/payment/bankTransferViewModel";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import { Col, Jumbotron, Row } from "react-bootstrap";
import { QRCode } from "react-qr-svg";
import SepaInstructions from "./sepaInstructions";
import classNames from "classnames";
import styles from "./bankTransfer.module.scss";

const DomesticInstructions: ViewComponent<BankTransferViewModel> = observer(({ vm }) => {
  const ta = (attribute: string, model?: string) => vm.localizationService.translateAttribute(model || "payment", attribute);
  const tg = (code: string) => vm.localizationService.translateGeneral(code);

  const QRCodeImage: React.FC<{ base64Svg: string }> = ({ base64Svg }) => {
    const svgXml = atob(base64Svg);
    return <div className={styles.qrCodeContainer} dangerouslySetInnerHTML={{ __html: svgXml }} />;
  };

  return (
    <Row className="position-relative">
      <Col xs={6}>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{ta("subject")}</span>
            <div>{tg("eshop.transfer.address")}</div>
            <div>{tg("eshop.transfer.country")}</div>
            <div>
              {ta("organizationIdentifier", "organization")}
              {": "}
              <span className={styles.disableLinkTel}>{tg("eshop.transfer.identificationNumber")}</span>
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={12}>
        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{ta("bankAccount")}</span>
            <div style={{ wordBreak: "break-all", wordWrap: "break-word" }}>
              <span className={styles.disableLinkTel}>{formatBankAccount(vm.domesticPayment?.bankAccount)}</span>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <span className="font-weight-bold">{ta("variableSymbol")}</span>
            <div className="text-nowrap">
              <span className={styles.disableLinkTel}>{vm.variableSymbol || "-"}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <span className="font-weight-bold">{ta("price")}</span>
            <div className="text-nowrap">{vm.priceDomestic || "-"}</div>
          </Col>
        </Row>
      </Col>
      {vm.qrcode && (
        <div className={`${styles.qrCodeFixed} ${styles.qrCodeContainer} pl-3`}>
          <QRCodeImage base64Svg={vm.qrcode} />
        </div>
      )}
    </Row>
  );
});

export default DomesticInstructions;
